import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { HOME, CALLBACK, TEAM_HOME, SIGN_OUT, TEAM } from './routerConstants';
import * as Screens from 'screens';
import { PrivateRoute } from 'components/PrivateRoute';

const Router: React.FC = () => {
	return (
		<BrowserRouter>
			<Switch>
				<Route {...TEAM} exact component={Screens.Team} />
				<Route {...HOME} component={Screens.Home} />
				<Route {...CALLBACK} component={Screens.Callback} />
				{/* Note that the TeamHome component has a switch router in it (TeamHomeRouteSwitch). 
				If you can't find what you're looking for on this screen, check there.*/}
				<PrivateRoute {...TEAM_HOME} component={Screens.TeamHome} />
				<Route {...SIGN_OUT} component={Screens.SignOut} />
				<Route path='*' render={() => <Redirect to='/' />} />
			</Switch>
		</BrowserRouter>
	);
};

export default Router;